import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleWhatIs from "../pages/article/what-is-acbuyspreadsheet/page";
import ArticleHowTo from "../pages/article/how-to-use-acbuyspreadsheet/page";
import ArticleVsShopping from "../pages/article/acbuyspreadsheet-vs-traditional-shopping/page";
import ArticleBenefits from "../pages/article/benefits-of-spreadsheet-buying/page";
import ArticleCategories from "../pages/article/acbuyspreadsheet-categories-guide/page";
import ArticleSafe from "../pages/article/is-acbuyspreadsheet-safe/page";
import ArticleShoppingGuide from "../pages/article/acbuyspreadsheet-shopping-guide/page";
import ArticleTips from "../pages/article/top-acbuyspreadsheet-tips/page";
import ArticleFaq from "../pages/article/acbuyspreadsheet-faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/what-is-acbuyspreadsheet",
    element: <ArticleWhatIs />,
  },
  {
    path: "/article/how-to-use-acbuyspreadsheet",
    element: <ArticleHowTo />,
  },
  {
    path: "/article/acbuyspreadsheet-vs-traditional-shopping",
    element: <ArticleVsShopping />,
  },
  {
    path: "/article/benefits-of-spreadsheet-buying",
    element: <ArticleBenefits />,
  },
  {
    path: "/article/acbuyspreadsheet-categories-guide",
    element: <ArticleCategories />,
  },
  {
    path: "/article/is-acbuyspreadsheet-safe",
    element: <ArticleSafe />,
  },
  {
    path: "/article/acbuyspreadsheet-shopping-guide",
    element: <ArticleShoppingGuide />,
  },
  {
    path: "/article/top-acbuyspreadsheet-tips",
    element: <ArticleTips />,
  },
  {
    path: "/article/acbuyspreadsheet-faq",
    element: <ArticleFaq />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;